/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Extra_Session_Reserve_OtherInputs */

const fr_extra_session_reserve_other = /** @type {(inputs: Extra_Session_Reserve_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dont ${i?.count} séances achetées en réserve`)
};

/**

* @param {Extra_Session_Reserve_OtherInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const extra_session_reserve_other = /** @type {((inputs: Extra_Session_Reserve_OtherInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extra_Session_Reserve_OtherInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_extra_session_reserve_other(inputs)
});